import Script from "next/script";
import usePlacesAutocomplete from "use-places-autocomplete";

const CALLBACK_NAME = "initAutocomplete";
const GMAPS_API_KEY = process.env.NEXT_PUBLIC_GMAPS_API_KEY;

export const GoogleMapsApiLoader: React.FC<React.PropsWithChildren> = ({ children }) => {
    // `usePlacesAutocomplete` needs to be called with a callbackName before the script is loaded
    usePlacesAutocomplete({
        callbackName: CALLBACK_NAME,
    });

    return (
        <>
            {GMAPS_API_KEY && (
                <Script
                    src={`https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&libraries=places&callback=${CALLBACK_NAME}`}
                />
            )}
            {children}
        </>
    );
};
